exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-form-design-shortcut-dropdown.dropdown-menu .suggest-option-prefix{margin-right:.375rem;color:var(--fts-default);font-size:.75rem;white-space:nowrap}", ""]);

// exports
